export default {"src":"/_next/static/media/calendar-green.6ea4bc78.svg","height":21,"width":19,"blurWidth":0,"blurHeight":0};